module.exports = __webpack_public_path__ + "static/media/main idea.f1a709b3.mp3";